import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import ProgressBar from 'components/global/ProgressBar';
import moment from 'moment';
import { formatMoneyShorthand } from 'utils/formatMoney';

const getStatus = (deal) => {
  if (deal.isCurrent) return { text: 'Primary', color: 'primary' };
  if (deal.isActive) return { text: 'Active', color: 'success' };
  return { text: 'Inactive', color: 'danger' };
};

const FounderDealsRows = ({ data }) => data.map((deal) => ({
  ...deal,
  id: deal.id,
  currentValue: formatMoneyShorthand(deal.currentValue || 0),
  progress: (
    <ProgressBar
      value={(deal.amountCommitted / deal.currentRaiseSize) * 100}
      displayText={`${formatMoneyShorthand(deal.amountCommitted || 0)} / ${formatMoneyShorthand(deal.currentRaiseSize || 0)} committed`}
    />
  ),
  name: deal.name || `Untitled Deal - ${deal.id}`,
  Status: (
    <span className={`text-capitalize fw-bold text-${getStatus(deal).color}`}>
      {getStatus(deal).text}
    </span>
  ),
  publicPrivate: deal.isPublic ? 'Public' : 'Private',
  CreatedAt: moment(deal.createdAt).format('MM/DD/YYYY'),
  Actions: (
    <ContextMenu
      menuItems={[
        // Todo: figure out why fundingDate is not being passed in correctly and we need to add 1 day to it
        { label: 'Edit', onClick: () => { handleShowModal('founder-edit-deal', { ...deal, fundingDate: moment(deal.fundingDate).add(1, 'day').format('YYYY-MM-DD'), dealName: deal.name || `Untitled Deal - ${deal.id}` }); } },
        { label: 'Delete', onClick: () => { handleShowModal('founder-deal-delete', { id: deal.id, name: deal.name || `Untitled Deal - ${deal.id}` }); } },
      ]}
    />
  ),
}));

export default FounderDealsRows;
